export const GEOJS_URL = 'https://get.geojs.io/v1/ip/country.json';
export const EXTRA_SMALL_SCREEN = 375;
export const SMALL_SCREEN = 576;
export const MEDIUM_SCREEN = 768;
export const LARGE_SCREEN = 992;
export const EXTRA_LARGE_SCREEN = 1200;
export const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w{2,}([-.]\w{2,})*$/;
export const NUMBER_REGEX = /^[\d]+$/;
export const APLHANUMERIC_WITH_ONE_SPACE_REGEX = /^([A-z0-9À-ž]+\s)*[A-z0-9À-ž]+$/;
export const SORT_CODE_REGEX = /^(\d{6}|(\d{2}-){2}\d{2})$/; // ex. 12-44-15
export const BRANCH_CODE_REGEX = /^[\w0-9]+(?: [\w0-9]+)*$/;
export const ACCOUNT_NUMBER_REGEX = /^[0-9]+(?: [0-9]+)*$/;
export const MAX_MAKE_AN_OFFER_AMOUNT = 2_000_000_000;
export const UPLOAD_ENDPOINT = '/upload-file';
export const REMOVE_ENDPOINT = '/remove-file';
export const UPLOAD_FILE_AS_UNREGISTERED_USER =
  '/upload-file-as-unregistered-user';
export const REMOVE_FILE_AS_UNREGISTERED_USER =
  '/remove-file-as-unregistered-user';
export const FAVOURITE_PROPERTY_ENDPOINT = '/favourites';
export const CATALOGUE_ENDPOINT = '/catalogue';
export const ARP_PAYMENT_SERVICE_ENDPOINT = '/payment-service';
export const BOD_PAYMENT_SERVICE_ENDPOINT = '/bod/payment-service';
export const ENV = {
  DEV: 'DEV',
  PRD: 'PRD',
  PPT: 'PPT',
  SIT: 'SIT',
};
export const DATA_AMOUNT = 'data-amount';

export const getSignalRHubUrlForEnv = (bidhubBaseUrl) =>
  `${bidhubBaseUrl.toLowerCase()}/signalr`;
export const CREATE_ADDITIONAL_PARTICIPANT_ENDPOINT =
  '/create-additional-participant';
export const SELECT_ADDITIONAL_PARTICIPANT_ENDPOINT =
  '/select-additional-participant';
export const REMOVE_ADDITIONAL_PARTICIPANT_ENDPOINT =
  '/remove-additional-participant';
export const GET_AVAILABLE_ADDITIONAL_PARTICIPANTS_ENDPOINT =
  '/list-available-additional-participants';
export const SEND_EMAIL_CONFIRM_LEGAL_DOCUMENTS =
  '/send-email-confirm-legal-documents';
export const AUCTION_MAKE_AN_OFFER_ENDPOINT = '/auction-make-an-offer';

export const FILE_UPLOAD_ELEMENTS_IDS = [
  'photo-id',
  'address-id',
  'selfie-id',
  'proof-of-incorporation-id',
  'declaration-of-ownership-id',
  'management-structure-id',
  'office-address-id',
  'resolution-document-id',
  'proof-of-funds',
  'identity-document',
  'memorandum-and-articles-of-association',
];

export const LEGAL_DOCUMENTS_INTERESTED_PARTIES_ENDPOINT =
  '/legal-documents-interested-parties';
export const LEGAL_DOCUMENTS_ENDPOINT = '/legal-documents';

export const DEFAULT_THRESHOLD = 5;

export const COUNTRY = {
  IRELAND: 1,
  UNITED_KINGDOM: 2,
  SOUTH_AFRICA: 3,
  CYPRUS: 4,
  SPAIN: 5,
  GREECE: 6,
};

export const BOUNDS_PER_REGION = {
  [COUNTRY.IRELAND]: {
    nelat: 55.500856,
    nelng: -5.367507,
    swlat: 51.280239,
    swlng: -10.741666,
  },
  [COUNTRY.UNITED_KINGDOM]: {
    nelat: 58.845397,
    nelng: 1.793995,
    swlat: 49.945024,
    swlng: -8.434331,
  },
  [COUNTRY.SPAIN]: {
    nelat: 43.932037,
    nelng: 3.936047,
    swlat: 27.631898,
    swlng: -18.44969,
  },
  [COUNTRY.CYPRUS]: {
    nelat: 35.742481,
    nelng: 34.779157,
    swlat: 34.556769,
    swlng: 32.128705,
  },
  [COUNTRY.SOUTH_AFRICA]: {
    nelat: -21.522338,
    nelng: 35.747655,
    swlat: -36.046625,
    swlng: 15.030932,
  },
  [COUNTRY.GREECE]: {
    nelat: 41.753048,
    nelng: 26.699791,
    swlat: 36.064831,
    swlng: 20.118981,
  },
};

export const MAP_OPTIONS_PER_REGION = {
  [COUNTRY.IRELAND]: {
    zoom: 7,
    threshold: DEFAULT_THRESHOLD,
    center: {
      lat: 53.342927,
      lng: -7.867683,
    },
  },
  [COUNTRY.UNITED_KINGDOM]: {
    zoom: 6,
    threshold: DEFAULT_THRESHOLD,
    center: {
      lat: 50.842927,
      lng: -1.067683,
    },
  },
  [COUNTRY.SOUTH_AFRICA]: {
    zoom: 6,
    threshold: 4,
    center: {
      lat: -29.964912,
      lng: 24.908899,
    },
  },
  [COUNTRY.CYPRUS]: {
    zoom: 9,
    threshold: DEFAULT_THRESHOLD,
    center: {
      lat: 35.086298,
      lng: 33.211859,
    },
  },
  [COUNTRY.SPAIN]: {
    zoom: 7,
    threshold: 4,
    center: {
      lat: 39.873914,
      lng: -3.437683,
    },
  },
};

export const MAP_OPTIONS_PER_REGION_MOBILE = {
  [COUNTRY.IRELAND]: {
    ...MAP_OPTIONS_PER_REGION[COUNTRY.IRELAND],
    zoom: 6,
  },
  [COUNTRY.UNITED_KINGDOM]: {
    ...MAP_OPTIONS_PER_REGION[COUNTRY.UNITED_KINGDOM],
    zoom: 5,
    threshold: 4,
    center: {
      lat: 54.552927,
      lng: -3.067683,
    },
  },
  [COUNTRY.SOUTH_AFRICA]: {
    ...MAP_OPTIONS_PER_REGION[COUNTRY.SOUTH_AFRICA],
    threshold: 3,
    zoom: 5,
  },
  [COUNTRY.CYPRUS]: {
    ...MAP_OPTIONS_PER_REGION[COUNTRY.CYPRUS],
    zoom: 8,
  },
  [COUNTRY.SPAIN]: {
    ...MAP_OPTIONS_PER_REGION[COUNTRY.SPAIN],
    threshold: 3,
    zoom: 6,
  },
};
